export default "__VITE_ASSET__2RfoPThS__"